import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './services/auth/auth.guard';
import { AuthorizationService } from './services/auth/auth.service';
import { HttpClientService } from './services/http/httpClient.service';
import { HttpHeadersService } from './services/http/httpHeaders.service';
import { ErrorDialogService } from './services/http/error/error-dialog.service';
import { UserService } from './services/user/user.service';
import { SharedModule } from './../shared/shared.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, SharedModule],
  exports: [SharedModule],
  providers: [AuthGuard,
    HttpClientService,
    HttpHeadersService,
    AuthorizationService,
    UserService,
    ErrorDialogService,
  ]
})
export class CoreModule { }
